import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface UserState {
	accessToken?: string;
	isDoctor: boolean;
	isNurse: boolean;
	isPatient: boolean;
	isManager: boolean;
	rolesLoaded: boolean;
	rolesLoading: boolean;
	allowedWorkplaces: { id: string; name: string }[];
}

const initialState: UserState = {
	accessToken: undefined,
	isPatient: false,
	isDoctor: false,
	isNurse: false,
	isManager: false,
	rolesLoaded: false,
	rolesLoading: false,
	allowedWorkplaces: [],
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUserIsDoctor: (state, { payload }) => {
			state.isDoctor = payload;
		},
		setUserIsPatient: (state, { payload }) => {
			state.isPatient = payload;
		},
		setUserIsNurse: (state, { payload }) => {
			state.isNurse = payload;
		},
		setUserIsManager: (state, { payload }) => {
			state.isManager = payload;
		},
		setUserRolesLoaded: (state, { payload }) => {
			state.rolesLoaded = payload;
		},
		setUserRolesLoading: (state, { payload }) => {
			state.rolesLoading = payload;
		},
		storeUser: (state, { payload }) => {
			state.accessToken = payload.accessToken;
		},
		removeUser: state => {
			// state = {
			// 	accessToken: undefined,
			// };
		},
		setUserAllowedWorkplaces: (state, { payload }) => {
			state.allowedWorkplaces = payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	storeUser,
	removeUser,
	setUserIsDoctor,
	setUserIsNurse,
	setUserIsPatient,
	setUserIsManager,
	setUserRolesLoaded,
	setUserRolesLoading,
	setUserAllowedWorkplaces,
} = userSlice.actions;

export const selectUser = (state: RootState) => state.user;
export const selectUserIsLoggedIn = (state: any) => !!state.user.accessToken;
export const selectUserAllowedWorkplaces = (state: any) =>
	state.user.allowedWorkplaces;

export default userSlice.reducer;
